/**
 * @generated SignedSource<<ad1b6cc24bb787ab511eebae6a523985>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type JobLink_job$fragmentType = any;
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type Row_job$fragmentType: FragmentType;
export type Row_job$data = {|
  +agentQueryRules?: ?$ReadOnlyArray<string>,
  +concurrency?: ?{|
    +group: string,
    +limit: number,
  |},
  +createdAt?: ?any,
  +id?: string,
  +passed?: boolean,
  +priority?: {|
    +number: ?number,
  |},
  +state?: JobStates,
  +$fragmentSpreads: JobLink_job$fragmentType,
  +$fragmentType: Row_job$fragmentType,
|};
export type Row_job$key = {
  +$data?: Row_job$data,
  +$fragmentSpreads: Row_job$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Row_job",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JobPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentQueryRules",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "passed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JobConcurrency",
          "kind": "LinkedField",
          "name": "concurrency",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "group",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "limit",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "type": "JobTypeCommand",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobLink_job"
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node/*: any*/).hash = "e059f02d35d55e9902c5cbfa7212a64d";

module.exports = ((node/*: any*/)/*: Fragment<
  Row_job$fragmentType,
  Row_job$data,
>*/);
